__webpack_require__.p = "/Quotes-Generator/";